/**
 * Shared validation helpers used across the CRM contact creation flows.
 */

const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function isValidEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim();
  if (!trimmed || trimmed.length > 254) return false;
  return EMAIL_RE.test(trimmed);
}

export function emailValidationError(email) {
  if (!email || !email.trim()) return 'Email is required';
  if (!isValidEmail(email)) return 'Enter a valid email address (e.g. name@company.com)';
  return null;
}
